<script setup>
import { ref, onMounted, defineProps, defineModel, watch } from 'vue' 
import debounce from 'lodash.debounce'
import MemberApi from '@/services/MemberApi';

const crtProps = defineProps(['label', 'variant']);
const members = ref([])
const model = defineModel({type: Object, default: { memberId: 0, name: ""} })
const selectedMember = ref()
const loading = ref(false)

const searchMembers = debounce(async (term) => {
    loading.value = true
    MemberApi.search({ offset: 0, limit: 25, search: term }).then((response) => {
        if (response && response.data && Array.isArray(response.data.members)) {
            var memberList = [];
            var resMember = response.data.members;
            for(var i in resMember) {
                memberList.push({
                    memberId: resMember[i].memberId,
                    name: resMember[i].firstName + ' ' + resMember[i].lastName
                })
            }
            members.value = memberList;   
        }
    }).finally(() => {
        loading.value = false
        if(term) {
            selectedMember.value = term
        }
    })
})

onMounted(() => {
    if(model.value && model.value.memberId > 0 && model.value.name) {
        searchMembers(model.value.name)
    }
    else {
        searchMembers(undefined)
    }
})

const handleMemberUpdate = (value) => {
    let member = members.value.find(x => x.memberId == value);
    if(member) {
        model.value = member;
    }
    else {
        model.value = { memberId: 0, name: ""};
    }
}

watch(model, (value) => {
    if(value && value.memberId > 0 && value.name) {
        searchMembers(value.name)
    }
    else {
        searchMembers(undefined)
    }
})

</script>

<template>
        <div :class="crtProps.class">
            <v-autocomplete
                :variant="crtProps.variant ? crtProps.variant : 'solo'" 
                item-title="name"
                item-value="memberId" 
                density="compact" 
                :label="crtProps.label"
                :loading="loading"
                :items="members"
                v-model="selectedMember"
                @update:search="searchMembers"
                @update:model-value="handleMemberUpdate"
                autocomplete="one-time-code"
                hide-details
                :clearable="true">
            </v-autocomplete>
        </div>
</template>